import * as React from 'react'
import moment from 'moment'
import * as _ from 'lodash'
import { VariablesObj, WorkerTypeTStrings } from '../../../../types/Company'

import { CogsLineItemT } from '../FinancialTab/CogsLineItemUtils'

import { copyObject, randomId } from '../../../../utils'

import { getVariableValue } from '../DocumentsTab/DocumentVariables'

import { convertItemByWorker, extractImpliedLineDate, getJobDuration, getWorkerFlatPay, getWorkerPay, workerPayIsLaborFlat } from '../JobUtils'
import { InvoiceWorkerT, JobWorkerT } from '../../../../types/JobWorker'
import { getActivitiesInvoice } from './FilterCrewWorker'
import { ActivityInvoiceT, EstimateLineItemT, ExpenseLineItemT, JobT, RevenueLineItemT } from '../../../../types/Job'
import { CogsLineItemObj, FinancialObj } from '../InitObjectJob'
import { parseFloatTotal } from '../../../../utils/utilsT'


const resolveInvoiceLineItem = (invoiceLineItems: Array<InvoiceWorkerT>, jobDuration: number, hourlyRate: number, isLaborFlat: boolean): Array<InvoiceWorkerT> => {
    return invoiceLineItems.map((findInvoiceLine, index) => {
        if (findInvoiceLine?.isDirty == false) {
            let units = isLaborFlat ? 1 : Number(parseFloatTotal(`${jobDuration}`))
            if (!_.has(findInvoiceLine, "id") || !findInvoiceLine.id) {
                findInvoiceLine.id = randomId()
            }
            findInvoiceLine.rate = hourlyRate
            findInvoiceLine.units = units
            findInvoiceLine.total = Number(parseFloatTotal(`${hourlyRate * units}`))
        }
        return findInvoiceLine
    })
}

/**
 * 
 * @param jobWorker 
 * @param activitiesItems 
 * @param isLaborFlat 
 * @param jobDuration 
 * @param workerFlatPay 
 * @param workerPay 
 * @returns JobWorkerT
 */
const calculateJobWorkerInvoice = (
    crew: JobWorkerT,
    activitiesItems: Array<ActivityInvoiceT>,
    isLaborFlat: boolean,
    jobDuration: number,
    workerFlatPay: number,
    workerPay: number): JobWorkerT => {

    // if remove any item from invoice this mean isDirty 
    if (crew?.isDirty == true) {
        return crew;
    }

    let invoice = _.isArray(crew?.invoice) ? crew.invoice : []

    let newInvoices = []
    let hourlyRate = 0
    hourlyRate = isLaborFlat ? Number(parseFloatTotal(`${workerFlatPay}`)) : Number(parseFloatTotal(`${workerPay}`))
    /**
     * if worker not anonymous and not labor flat get hourly rate of worker 
     */
    if (crew.id > 0 && !isLaborFlat) {
        hourlyRate = Number(parseFloatTotal(`${crew.hourlyRate}`))
    }


    const generateInvoiceByActivityInvoice = (activityInvoice: ActivityInvoiceT, jobDuration: number, isLaborFlat: boolean): InvoiceWorkerT => {
        let rate = Number(parseFloatTotal(`${hourlyRate}`))
        // if laborFlat set 1 for units
        let units = isLaborFlat ? 1 : Number(parseFloatTotal(`${activityInvoice.duration}`))
        units = !isLaborFlat && !activityInvoice.duration ? jobDuration : units
        let total = Number(parseFloatTotal(`${rate * units}`))
        let newInvoiceLine: InvoiceWorkerT = {
            id: activityInvoice.id,
            date: null,
            item: isLaborFlat ? "laborFlat" : "laborVariable",// for now we have just this item 
            rate: rate,
            units: units,
            total: total,
            isDirty: false,
            isAutoFill: true,
        }
        return newInvoiceLine
    }


    activitiesItems.map((activityInvoice, index) => {

        let newInvoiceLine: InvoiceWorkerT = generateInvoiceByActivityInvoice(activityInvoice, jobDuration, isLaborFlat)

        newInvoiceLine.date = activityInvoice.activityDate
        let findindex = invoice.findIndex((invoiceLline, index) => {
            return (!_.has(activityInvoice, "id") && !_.has(invoiceLline, "id") && invoiceLline?.isAutoFill == true)
                || _.isEqual(invoiceLline.id, activityInvoice.id)
        })

        if (findindex != -1) {
            let findInvoiceLine = invoice[findindex]
            if (findInvoiceLine?.isDirty == false) {
                // use AutoFill
                newInvoices.push(newInvoiceLine)
            } else {
                /**
                 *  use old item
                 *  not refresh from activity 
                 */
                if (findInvoiceLine?.id) {
                    findInvoiceLine.id = randomId()
                }
                // console.log("findInvoiceLine", findInvoiceLine)
                newInvoices.push(findInvoiceLine)
            }

        } else {
            newInvoices.push(newInvoiceLine)
        }

    })


    let invoiceLineItemsManually = _.filter(invoice, (invoiceNewLine, index) => {
        return !invoiceNewLine?.isAutoFill 
    })


    invoiceLineItemsManually = resolveInvoiceLineItem(invoiceLineItemsManually, jobDuration, hourlyRate, isLaborFlat)
    // @ts-ignore
    let cloneNewInvoice = [...newInvoices]
    if (invoiceLineItemsManually.length > 0) {
        cloneNewInvoice = [...newInvoices, ...invoiceLineItemsManually]
    }

    crew.invoice = copyObject(cloneNewInvoice)
    return crew
}

/**
 * 
 * @param job 
 * @returns Array<JobWorkerT>
 */
const calculateCrewInvoice = (job: JobT): Array<JobWorkerT> => {
    let items = []
    const workerPay = getWorkerPay(job)
    const workerFlatPay = getWorkerFlatPay(job)
    const locations = _.isArray(job.locations) ? job.locations : []

    const activitiesItems = getActivitiesInvoice(locations)
    const jobDuration = getJobDuration(job)
    const isLaborFlat = workerPayIsLaborFlat(job)

    let crew = job.crew.map((crew) => {
        return calculateJobWorkerInvoice(crew, activitiesItems, isLaborFlat, jobDuration, workerFlatPay, workerPay)
    })
    let cloneCrew = copyObject(crew)
    console.log("calculateCrewInvoice->activitesInvoice->jobDuration", jobDuration)
    // console.log("calculateCrewInvoice->activitesInvoice->crew", cloneCrew)
    return cloneCrew
}



const OptionsItemCogs = {
    'load': 'movingLabor',
    'unload': 'movingLabor',
    'pack': 'packingLabor',
    'estimate': 'other',
}




/**
 * 
 * @param workerName 
 * @param item 
 * @returns 
 */
export const convertItemByWorkerName = (workerName: string, item: WorkerTypeTStrings, index: number): [string, string] => {
    let variableName = workerName == ' ' ? `worker${index + 1}` : _.camelCase(workerName)
    let _item = item == "laborFlat" ? "laborFlat" : "laborVariable"
    return [_item, variableName];
}


/**
 * find item paid but not have id and it's autofill 
 * @param lineItem 
 * @param lineItemRevenue 
 * @returns 
 */
export const isMatchRevenuLineItem = (lineItem: EstimateLineItemT, lineItemRevenue: RevenueLineItemT): boolean => {
    if ((lineItem.item == lineItemRevenue.item
        && (lineItemRevenue?.isAutoFill == true || lineItemRevenue?.paid == true)
        && lineItem.total == lineItemRevenue.total
        && lineItem.rate == lineItemRevenue.rate
        && lineItem.units == lineItemRevenue.units) || lineItemRevenue?.isDirty == true) {
        // console.log("itemsRevenue->isMatchRevenuLineItem", "true")
        return true
    }
    return false
}

/**
 * 
 * @param job 
 * @param lineItems 
 * @returns 
 */
export const calculateRevenue = (job: JobT, lineItems: Array<EstimateLineItemT>): Array<RevenueLineItemT> => {
    let itemsRevenue = []
    let cloneRevenue: Array<RevenueLineItemT> = _.isArray(job?.financial?.revenue?.lineItems) ? job?.financial?.revenue?.lineItems : []
    console.log("itemsRevenue->cloneRevenue", cloneRevenue)
    console.log("itemsRevenue->lineItems ", lineItems)

    const generateNewItem = (item) => {
        let newItem: RevenueLineItemT = {
            id: !_.isNil(item.id) ? item.id : randomId(12),
            item: item.item,
            date: item?.lineItemDate ? `${item?.lineItemDate}` : "",
            // other: item.type,
            rate: Number(parseFloat(`${item?.rate}`).toFixed(2)),
            units: item.units,
            total: item.total,
            isAutoFill: true,
        }
        return newItem
    }


    /**
     * read lineItems from estimate
     */
    lineItems.map((item, index) => {

        let findRevenue = cloneRevenue.find((x) => x.id == item.id || isMatchRevenuLineItem(item, x))
        console.log("itemsRevenue->findRevenue", findRevenue)
        if (findRevenue) {
            if (!findRevenue?.isDirty  && !findRevenue?.paid) {
                const newItem = generateNewItem(item)
                itemsRevenue.push(newItem)
            } else if (findRevenue?.isAutoFill == true) {
                itemsRevenue.push(findRevenue)
            }
        } else {
            const newItem = generateNewItem(item)
            itemsRevenue.push(newItem)
        }

    })
  
    let lineItemsManually = _.filter(cloneRevenue, (lineItem, index) =>  !lineItem?.isAutoFill)

    // @ts-ignore
    itemsRevenue = [...itemsRevenue, ...lineItemsManually]

    console.log("itemsRevenue", itemsRevenue)
    return itemsRevenue;
}

/**
 * 
 * @param jobWorker JobWorkerT
 * @param invoiceLineItem 
 * @param indexCrew 
 * @param index 
 * @returns 
 */
const generateCogsByJobWorker = (jobWorker: JobWorkerT, invoiceLineItem: InvoiceWorkerT, indexCrew: number, index: number): CogsLineItemT => {
    let rate = Number(parseFloat(`${invoiceLineItem.rate}`).toFixed(2))
    let units = Number(parseFloat(`${invoiceLineItem.units}`).toFixed(2))
    let total = Number(parseFloat(`${rate * units}`).toFixed(2))
    let _item: WorkerTypeTStrings = invoiceLineItem.item == "laborFlat" ? "laborFlat" : "laborVariable"
    const resultConvert = convertItemByWorker(jobWorker, _item, indexCrew)
    let id = `${invoiceLineItem.id}:<${resultConvert.variableName}>:${indexCrew}:${index}`
    // let workerId = crew.id != 0 ? crew.id : `worker${indexCrew + 1}`
    let itemCogs: CogsLineItemT = {
        id: id,
        date: invoiceLineItem.date,
        item: resultConvert.key,
        rate: invoiceLineItem.rate,
        units: invoiceLineItem.units,
        total: total,
        isAutoFill: true,
        isDirty: false,
        workerId: jobWorker.id
    }
    return itemCogs
}


const resolveCogsId = (jobWorker: JobWorkerT, invoiceLineItem: InvoiceWorkerT, indexCrew: number, index: number): string => {
    let _item: WorkerTypeTStrings = invoiceLineItem.item == "laborFlat" ? "laborFlat" : "laborVariable"
    const resultConvert = convertItemByWorker(jobWorker, _item, indexCrew)
    let id = `${invoiceLineItem.id}:<${resultConvert.variableName}>:${indexCrew}:${index}`
    return id
}


/**
 * 
 * @param job 
 * @returns 
 */
export const calculateCogs = (job: JobT): Array<CogsLineItemT> => {
    let cogsItems: Array<CogsLineItemT> = []
    let cloneCogs: Array<CogsLineItemT> = _.isArray(job?.financial?.cogs?.lineItems) ? job.financial.cogs.lineItems : []

    const crewInvoice = calculateCrewInvoice(job)
    console.log("calculateCogs->cloneCogs", cloneCogs)
    console.log("calculateCogs->crewInvoice->crew", crewInvoice)
    // console.log("cloneCogs->crewInvoice", crewInvoice)


    crewInvoice.map((crew, indexCrew) => {
        let invoice = crew.invoice && _.isArray(crew.invoice) ? crew.invoice : []

        invoice.map((invoiceLineItem, index) => {
            let id = resolveCogsId(crew, invoiceLineItem, indexCrew, index)
            // let workerId = crew.id != 0 ? crew.id : `worker${indexCrew + 1}`
            let itemCogs: CogsLineItemT = generateCogsByJobWorker(crew, invoiceLineItem, indexCrew, index)
            console.log("calculateCogs->id", id)
            let findindex = cloneCogs.findIndex((cogsLineItem, index) => cogsLineItem.id == id)
            if (findindex != -1) {
                let findCogsLineItem = cloneCogs[findindex]          
                if ( !findCogsLineItem?.isDirty) {
                    // use AutoFill
                    cogsItems.push(itemCogs)

                } else {
                    // console.log("findCogsLineItem", findCogsLineItem)
                    if (findCogsLineItem?.isAutoFill == true) {
                        /**
                         *  use old item
                         * 
                         */
                        console.log("calculateCogs->findCogsLineItem", findCogsLineItem)
                        cogsItems.push(findCogsLineItem)
                    }
                }
            } else {
                cogsItems.push(itemCogs)
            }

        })
    })

 
    let cogsLineItemsManually = _.filter(cloneCogs, (cogsLineItem, index) =>  !cogsLineItem?.isAutoFill)
 
    // @ts-ignore
    cogsItems = [...cogsItems, ...cogsLineItemsManually]
    if (cogsItems.length <= 0) {
        cogsItems.push(copyObject(CogsLineItemObj))
    }
    // console.log("cloneCogs->cogsItems", cogsItems)
    return cogsItems;
}

/**
 * 
 * @param impliedLineDate 
 * @param lineItems 
 * @returns 
 */
const updateLineItems = (impliedDate: string, lineItems: Array<CogsLineItemT | ExpenseLineItemT | RevenueLineItemT>): Array<CogsLineItemT | ExpenseLineItemT | RevenueLineItemT> => {
    let newLineItems = []
    lineItems.map((item, index) => {
        let newItem = { ...item }

        if (!item?.isDirty && !_.has(item, "paid")) {
            newItem.date = impliedDate
        }

        newLineItems.push(newItem)
    })
    return newLineItems;
}




/**
 * 
 * @param job 
 * @returns 
 */
const callback = (job: JobT): JobT => {
    let cloneJob = copyObject(job)

    const impliedDate = extractImpliedLineDate(job)

    if (!_.has(cloneJob, 'financial.revenue.lineItems')) {
        cloneJob.financial = copyObject(FinancialObj);
    }

    let newFinancial = { ...cloneJob.financial }

    Object.keys(cloneJob.financial).map((key, index) => {
        if (key != "cogs") {
            newFinancial[key].lineItems = updateLineItems(impliedDate, newFinancial[key].lineItems)
        }

    })
    // console.log("newFinancial", newFinancial)
    cloneJob.financial = copyObject(newFinancial)
    // console.log("newFinancial-> cloneJob", cloneJob.financial)

    if (job.financial && job.financial.revenue && cloneJob.financial.revenue && (!_.has(cloneJob.financial.revenue, 'isDirty') || cloneJob.financial.revenue.isDirty == false)) {
        const estiamteVariables = cloneJob.documents.estimate && cloneJob.documents.estimate.variables ? cloneJob.documents.estimate.variables : []
        let estimateLineItems = getVariableValue('lineItems', estiamteVariables)
        estimateLineItems = estimateLineItems ? estimateLineItems : []
        console.log("estimateLineItems", estimateLineItems)
        let revenue = calculateRevenue(cloneJob, estimateLineItems)

        cloneJob.financial.revenue.lineItems = revenue
    }

    if (job?.financial?.cogs && (!_.has(cloneJob.financial.cogs, 'isDirty') || cloneJob.financial.cogs.isDirty == false)) {
        cloneJob.financial.cogs.lineItems = calculateCogs(cloneJob)

    }
    // console.log("cloneJob.financial.revenue.lineItems", cloneJob.financial.revenue.lineItems)
    return cloneJob;
}



export const FilterFinancial = { callback: callback, priority: 5, name: "financial" }



